export default "__VITE_ASSET__CjUKBaG1__"